import { SEARCHVESSEL } from "../../actions/portal/";

export default function(state = "", action) {
  switch (action.type) {
    case SEARCHVESSEL:
      return action.payload;
    default:
  }

  return state;
}
